import {
    IEquipeVendasPorUsuario,
    IEquipeVendasUsuarioGeral,
} from "../../../Interfaces/Vendas/EquipeVendas/EquipeVendasInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export function ListarEquipeVendasDesvinculadosPorUsuarioService(
    IDUsuario: number
) {
    return Service(
        Axios.get<Array<IEquipeVendasPorUsuario>>(
            `/home/equipevendas/listarequipevendasdesvinculadosporusuario?IDUsuario=${IDUsuario}`
        )
    );
}

export function ListarEquipeVendasVinculadosPorUsuarioService(
    IDUsuario: number
) {
    return Service(
        Axios.get<Array<IEquipeVendasPorUsuario>>(
            `/home/equipevendas/listarequipevendasvinculadosporusuario?IDUsuario=${IDUsuario}`
        )
    );
}

export function VincularEquipeVendasUsuarioService(
    requestBody: Array<IEquipeVendasUsuarioGeral>
) {
    return Service(
        Axios.put(`/home/equipevendas/vincularequipevendasusuario`, requestBody)
    );
}

export function DesvincularEquipeVendasUsuarioService(
    requestBody: Array<number>
) {
    return Service(
        Axios.put(
            `/home/equipevendas/desvincularequipevendasusuario`,
            requestBody
        )
    );
}
